
import OdgovoriNaPitanjaChart from "./OdgovoriNaPitanjaChart";
import "./StatistikaAnketePage.css"
import "../Anketa/AddNewAnketa.css"
import OdgovoriNaTekstualnaPitanja from "./OdgovoriNaTekstualnaPitanja";

const StatistikaAnketePage = ({ anketaId }) => {
    return (
    
        <div className="container add-new-anketa-container"> 
        <div className="add-new-anketa-card">
        
            <OdgovoriNaPitanjaChart anketaId={anketaId} />
            <OdgovoriNaTekstualnaPitanja anketaId={anketaId} />
            </div>
        </div>
    );
};

export default StatistikaAnketePage;
